// extracted by mini-css-extract-plugin
module.exports = {"promoPartOne":"az_Rxc","promoPartTwo":"az_Sxc","promoCode":"az_Txc"};